<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={40 * scale} height={40 * scale} viewBox="0.6667 0.6667 26.6667 26.6667" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M14 0.666748C6.63996 0.666748 0.666626 6.64008 0.666626 14.0001C0.666626 21.3601 6.63996 27.3334 14 27.3334C21.36 27.3334 27.3333 21.3601 27.3333 14.0001C27.3333 6.64008 21.36 0.666748 14 0.666748ZM11.3333 18.6667V9.33341C11.3333 8.78675 11.96 8.46675 12.4 8.80008L18.6266 13.4667C18.9866 13.7334 18.9866 14.2667 18.6266 14.5334L12.4 19.2001C11.96 19.5334 11.3333 19.2134 11.3333 18.6667Z" />
</svg>
